<template>
    <div class="mb-2">
        <WarningNotification v-if="balance">
            <template #header>
                Your tenancy is in arrears by &pound;{{ balance | currency }}.
            </template>
            <template #main>
                <p>
                    If you haven't already, please pay your outstanding balance.
                </p>
                <p v-if="$meta.features.tenants.bank_account || $meta.features.tenants.online_payments">
                    <b-button
                        type="is-warning"
                        inverted
                        outlined
                        rounded
                        @click.prevent="showModal()"
                    >
                        Pay
                    </b-button>
                </p>
            </template>
        </WarningNotification>

        <Notification v-else>
            There are no outstanding payments for this tenancy.
        </Notification>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import WarningNotification from './WarningNotification.vue';
import Notification from './Notification.vue';
import PaymentModal from './PaymentModal.vue';

export default {
    components: {
        WarningNotification,
        Notification,
    },

    data() {
        return {
            isModalActive: false,
        };
    },

    computed: {
        ...mapState('tenancyProperty', [
            'property',
        ]),
        ...mapState('tenancyArrears', [
            'balance',
        ]),
    },

    watch: {
        property() {
            this.getArrears();
        },
    },

    mounted() {
        this.getArrears();
    },

    methods: {
        getArrears() {
            this.$store.dispatch('tenancyArrears/getBalance', this.property.TenancyFK);
        },
        showModal() {
            this.$buefy.modal.open({
                parent: this,
                component: PaymentModal,
                hasModalCard: true,
                props: {
                    balance: this.balance,
                    link: {
                        name: 'tenancy-property-pay',
                        params: {
                            id: this.property.TenancyFK,
                        },
                    },
                },
            });
        },
    },
};
</script>
